import { Star06 } from '@aktiia/design-system';
import { useTranslation } from 'react-i18next';

import { Layout, OrganizationDetails, OrganizationDevices, OrganizationUsers } from '../../../components/app';
import { Card } from '../../../components/common';
import { ModalName } from '../../../enums';
import { useOpenModal } from '../../../features/modals';
import { useFetchOrganizationDevices, useFetchOrganizationUsers } from '../../../features/organization';

export const OrganizationPage = () => {
  const { t } = useTranslation();
  const openFeatureFeedbackModal = useOpenModal(ModalName.FEATURE_FEEDBACK);

  useFetchOrganizationDevices();
  useFetchOrganizationUsers();

  return (
    <Layout>
      <div className="grid grid-cols-2 gap-6">
        <OrganizationDetails expanded={false} />
        <OrganizationDevices expanded={false} />
        <Card>
          <h3 className="typography-heading-large">{t('organization.title.dashboards')}</h3>
          <p className="typography-paragraph-3 mt-6">{t('organization.subtitle.dashboards')}</p>
          <div className="grow" />
          <div className="mt-5">
            <button
              className="flex items-center bg-global-neuchatel-20 p-2 rounded-lg"
              onClick={() => openFeatureFeedbackModal()}
            >
              <span className="typography-inline-highlight-2 text-text-primary mr-2">
                {t('organization.button.upcoming')}
              </span>
              <Star06 />
            </button>
          </div>
        </Card>
        <OrganizationUsers expanded={false} />
      </div>
    </Layout>
  );
};
